import { createFileRoute } from "@tanstack/react-router";

import { SigninForm } from "@/founder/signin/SigninForm";

export const Route = createFileRoute("/founder/signin")({
    component: RouteComponent,
});

function RouteComponent() {
    return <SigninForm />;
}
